import styled from "styled-components";
import { FlexContainers, Paragraph2 } from "../../../../components";
import { colors } from "../../../../consts";
import { IconButtonStyled } from "../../../../components/Buttons/styled";

export const MessagePreviewWrapper = styled.div`
  width: 100%;

  ${Paragraph2} {
    font-size: 14px;
    width: 500px;
  }
`;

export const Preview = styled(FlexContainers.FlexRowStart)`
  width: 100%;

  gap: 12px;

  background-color: ${colors.ISABELLINE};
  border-radius: 8px;
  padding: 16px;
`;

export const PreviewTitle = styled(Paragraph2)`
  font-size: 16px;
  font-weight: 600;
`;

export const PreviewMessage = styled(Paragraph2)`
  font-size: 16px;
`;

export const IconContainer = styled(FlexContainers.FlexRowStart)`
  padding: 0 4px;
  gap: 16px;

  svg {
    path {
      fill: ${colors.RAISIN_100};
    }
  }

  ${IconButtonStyled} {
    width: 26px;
    height: 26px;
  }
`;
